import { Getters, Mutations, Actions, Module, createMapper, } from "vuex-smart-module";
import axios from "axios";
const namespaced = true;
class DataState {
    constructor() {
        // contacts
        this.address = "Москва, Московский, 3-й мкр., д.11";
        this.addressLink = "https://yandex.ru/maps/?rtext=~55.595532,37.342095&rtt=mt";
        this.phone = "79299296609";
        this.whatsapp = null;
        this.instagram = {
            login: "@malinaclubmsk",
            link: "https://www.instagram.com/malinaclubmsk/",
        };
        // media
        this.videoLink = "https://www.instagram.com/p/CAOF_5lFxDJ/";
        // forms
        this.formCall = {
            data: [
                {
                    name: "name",
                    isShown: true,
                    value: null,
                    validationRequired: true,
                    isValid: false,
                    errorType: null,
                    errorMsg: null,
                },
                {
                    name: "phone",
                    isShown: true,
                    value: null,
                    validationRequired: true,
                    isValid: false,
                    errorType: null,
                    errorMsg: null,
                },
                {
                    name: "mail",
                    isShown: true,
                    value: null,
                    validationRequired: false,
                    isValid: true,
                    errorType: null,
                    errorMsg: null,
                },
            ],
            title: null,
            screen: null,
            error: null,
            errors: [
                { type: "empty", msg: "Поле не должно быть пустым" },
                { type: "wrongPhone", msg: "Некорректный формат номера" },
                { type: "wrongMail", msg: "Некорректный формат e-mail" },
            ],
            isLoading: false,
            validationIsShown: false,
        };
        this.formPres = {
            data: [
                {
                    name: "name",
                    isShown: true,
                    value: null,
                    validationRequired: true,
                    isValid: false,
                    errorType: null,
                    errorMsg: null,
                },
                {
                    name: "phone",
                    isShown: true,
                    value: null,
                    validationRequired: true,
                    isValid: false,
                    errorType: null,
                    errorMsg: null,
                },
            ],
            title: "Получить презентацию",
            screen: "Экран 4",
            error: null,
            errors: [
                { type: "empty", msg: "Поле не должно быть пустым" },
                { type: "wrongPhone", msg: "Некорректный формат номера" },
                { type: "wrongMail", msg: "Некорректный формат e-mail" },
            ],
            isLoading: false,
            validationIsShown: false,
        };
        this.formFaq = {
            data: [
                {
                    name: "mail",
                    isShown: true,
                    value: null,
                    validationRequired: true,
                    isValid: false,
                    errorType: null,
                    errorMsg: null,
                },
                {
                    name: "question",
                    isShown: true,
                    value: null,
                    validationRequired: true,
                    isValid: false,
                    errorType: null,
                    errorMsg: null,
                },
            ],
            title: "Задать вопрос",
            screen: "Экран 09",
            error: null,
            errors: [
                { type: "empty", msg: "Поле не должно быть пустым" },
                { type: "wrongPhone", msg: "Некорректный формат номера" },
                { type: "wrongMail", msg: "Некорректный формат e-mail" },
            ],
            isLoading: false,
            validationIsShown: false,
        };
        this.quiz = {
            data: [
                {
                    value: [["мальчик", null]],
                    question: "Пол&nbsp;и&nbsp;возраст ребенка",
                    answers: ["мальчик", "девочка"],
                    answersExtra: [
                        "до&nbsp;1&nbsp;года",
                        "1-3&nbsp;года",
                        "4-6&nbsp;лет",
                        "7-10&nbsp;лет",
                        "10-12&nbsp;лет",
                        "12+&nbsp;лет",
                    ],
                },
                {
                    value: [],
                    question: "Какое направление развития ребенка Вам интересно?",
                    answers: [
                        "раннее развитие",
                        "творчество",
                        "интеллектуальное развитие",
                        "спорт",
                        "занятия для школьников",
                        "другое",
                    ],
                },
                {
                    value: [],
                    question: "Сколько раз в&nbsp;неделю Вы готовы заниматься?",
                    answers: [
                        "1&nbsp;раз в&nbsp;неделю",
                        "2&nbsp;раза в&nbsp;неделю",
                        "3&nbsp;раза в&nbsp;неделю",
                        "каждый день",
                        "другое",
                    ],
                },
                {
                    value: [],
                    question: "Сколько Вы готовы потратить в&nbsp;месяц на&nbsp;ребенка?",
                    answers: [
                        "3.000-5.000&nbsp;рублей",
                        "5.000-10.000&nbsp;рублей",
                        "более 10.000&nbsp;рублей",
                        "другое",
                    ],
                },
            ],
            isLoading: false,
            error: null,
        };
        this.courses = [
            {
                id: 111,
                img: "/static/images/courses/image3.jpg",
                title: "Детская йога (5-8&nbsp;лет)",
                titleEng: "detskaya-yoga-5-8-let",
                list: [
                    "знакомство c&nbsp;возможностями тела",
                    "воспитание осмысленного отношения к&nbsp;собственному здоровью",
                    "упражнения на&nbsp;гибкость тела и&nbsp;развитие мышечной силы",
                ],
                price: "600",
                priceNumber: 600,
                schedule: "Группа: вт-чт в&nbsp;11.00",
                ticket: "Абонемент на&nbsp;2&nbsp;занятия по&nbsp;30&nbsp;минут",
                descr: '<p dir="ltr"><span>Йога для детей </span><span>&ndash; это комплекс йога упражнений, который способствует нормальному физическому и&nbsp;психическому развитию детского организма. Основная задача йоги для детей &mdash; укрепить здоровье и&nbsp;развить в&nbsp;ребенке внимательное и&nbsp;уважительное отношение к&nbsp;своему телу.</span></p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr">Наша программа занятий по&nbsp;детской йоге включает:&nbsp;</p>\
    <ul>\
    <li dir="ltr">\
    <p dir="ltr"><span>знакомство c&nbsp;возможностями тела,</span></p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr"><span>воспитание осмысленного отношения к&nbsp;собственному здоровью,</span></p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr"><span>формирование правильной осанки,</span></p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr"><span>упражнения на&nbsp;гибкость тела и&nbsp;развитие мышечной силы,</span></p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr"><span>развитие координации и&nbsp;пластики движения тела,</span></p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr"><span>игры-тренинги на&nbsp;приобретение навыков&nbsp;общения, наблюдательности, внимания, фантазии, активности.</span></p>\
    </li>\
    </ul>\
    ',
            },
            {
                id: 222,
                img: "/static/images/courses/image5.jpg",
                title: "Научись писать сочинение за несколько занятий (5-7&nbsp;классы)",
                titleEng: "nauchis-pisat-sochinenie-za-neskolko-zanyatiy-5-7-klassy",
                list: [
                    "умение осознавать тему, определить ее границы",
                    "умение систематизировать материал",
                    "умение определить основную мысль, составить план",
                ],
                price: "5 990",
                priceNumber: 5990,
                schedule: "Группа: ср в&nbsp;16.00",
                ticket: "Абонемент на&nbsp;16&nbsp;занятий по&nbsp;60&nbsp;минут (4&nbsp;месяца)",
                descr: '<p dir="ltr"><em>Курс позволяет обучить ребенка легко и&nbsp;непринужденно писать сочинения.</em></p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr">Сочинение &ndash; самостоятельная письменная работа учащихся, изложение ими собственных мыслей, наблюдений, переживаний, суждений. Это не только основное упражнение в&nbsp;построении текстов, но и&nbsp;средство самовыражения личности, развитие логического мышления и&nbsp;речи.</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr">В ходе подготовки к&nbsp;сочинению отрабатываются следующие коммуникативные умения:</p>\
    <ul>\
    <li dir="ltr">\
    <p dir="ltr">умение осознавать тему, определить ее границы;</p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr">умение отобрать и&nbsp;систематизировать материал в&nbsp;соответствии c&nbsp;темой, планом предлагаемого текста, его жанровой принадлежностью и&nbsp;стилем;</p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr">умение определить основную мысль, предположить ход ее поэтического раскрытия, составить план;</p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr">умение подобрать уместный языковой материал, соответствующий замыслу;</p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr">умение логично расположить материал, продумать переходы, варианты вступления и&nbsp;заключения;</p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr">умение записать составленный текст в&nbsp;соответствии c&nbsp;нормами русского литературного языка;</p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr">умение проверять и&nbsp;совершенствовать написанное.</p>\
    </li>\
    </ul>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr"><strong>Сочинение &ndash; обязательный этап в&nbsp;системе письменных проверочных работ.</strong></p>',
            },
            {
                id: 333,
                img: "/static/images/courses/image4.jpg",
                title: "Подготовка к&nbsp;написанию итогового сочинения (11&nbsp;класс)",
                titleEng: "podgotovka-k-napisaniyu-itogovogo-sochineniya-11-klass",
                list: [
                    "необходимые стилистические приемы",
                    "лаконичное и&nbsp;грамотное изложение мыслей",
                    "запас литературных примеров",
                    "изучение тем и&nbsp;основных тезисов",
                ],
                price: "18 990",
                priceNumber: 18990,
                schedule: "Группа: пн-ср 17.00",
                ticket: "Абонемент на&nbsp;36&nbsp;занятий по&nbsp;90&nbsp;минут 2&nbsp;раза в&nbsp;неделю (4&nbsp;месяца)",
                descr: '<div>\
    <p dir="ltr">Итоговое сочинение или изложение введено в&nbsp;качестве промежуточной аттестационной работы по&nbsp;русскому языку в&nbsp;2014 году и&nbsp;с тех пор является допуском к&nbsp;сдаче государственной итоговой аттестации. Традиционно проводится в&nbsp;декабре, в&nbsp;середине учебного года.</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr">Хорошее итоговое сочинение дает дополнительное преимущество при поступлении в&nbsp;институт. Ведь, как показывает практика, приемные комиссии ВУЗов&nbsp;обращают особое внимание на&nbsp;работу, добавляя до 10 конкурсных баллов&nbsp;исходя из собственных критериев! То есть кто-то может занять Ваше место в&nbsp;ВУЗе при одинаковых баллах по&nbsp;ЕГЭ за счет лучшего сочинения. Особенно это актуально для учебных заведений гуманитарного профиля.</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr">Итоговое сочинение призвано оценить способности школьников&nbsp;размышлять в&nbsp;пределах одной темы, обосновывать свою точку зрения, а также проверить усвоение программы мировой и&nbsp;отечественной литературы. Навык писать сочинения необходим практически во всех сферах деятельности, будь то составление научных докладов, литературных очерков&nbsp;или полицейских рапортов. Поэтому итоговое сочинение, прежде всего, оценивает культурный уровень автора, лаконичность стиля повествования, способности к&nbsp;анализу.</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr"><strong>Ваш ребенок научится не только лаконично и&nbsp;грамотно излагать свои мысли, но и&nbsp;освоит необходимые стилистические приемы, получит необходимый запас литературных примеров, изучит каждую тему и&nbsp;основные тезисы.&nbsp;</strong></p>\
    </div>\
    <p dir="ltr">&nbsp;</p>\
    ',
            },
            {
                id: 444,
                img: "/static/images/courses/image17.jpg",
                title: "Курс русского языка (5-7&nbsp;классы)",
                titleEng: "kurs-russkogo-yazika-5-7-klassy",
                list: [
                    "правила грамотного письма",
                    "построение сложных предложений и&nbsp;оборотов",
                    "словарные слова и&nbsp;выражения",
                    "особенности диктантов, сочинений и&nbsp;изложений",
                ],
                price: "2&nbsp;490",
                priceNumber: 2490,
                schedule: "Группа: ср в&nbsp;17.00",
                ticket: "Абонемент на&nbsp;4&nbsp;занятия по&nbsp;60&nbsp;минут",
                descr: '<div>\
    <p dir="ltr">Великий и&nbsp;прекрасный русский язык. Владея им на&nbsp;достойном уровне, ваш ребенок подтверждает статус умной и&nbsp;развитой личности. Ему открываются двери во многие ВУЗы. А в&nbsp;любой работе человек, способный грамотно и&nbsp;полноценно излагать своим мысли &ndash; письменно и&nbsp;устно &ndash; ценится очень высоко.</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr"><strong>На нашем курсе Ваш ребенок освоит:</strong></p>\
    <ul>\
    <li dir="ltr">\
    <p dir="ltr">последовательно выучит многочисленные правила грамотного письма</p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr">разберется в&nbsp;построении сложных предложений и&nbsp;оборотов</p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr">запомнит назубок словарные слова и&nbsp;выражения</p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr">вникнет в&nbsp;особенности диктантов, сочинений и&nbsp;изложений</p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr">научится красиво и&nbsp;правильно писать, говорить и&nbsp;даже думать на&nbsp;русском языке.</p>\
    </li>\
    </ul>\
    <p dir="ltr">&nbsp;</p>\
    </div>\
    <p dir="ltr">&nbsp;</p>\
    ',
            },
            {
                id: 555,
                img: "/static/images/courses/image6.png",
                title: "Олимпиадная математика (1-2,&nbsp;3-4&nbsp;классы)",
                titleEng: "olimpiadnaya-matematika-1-2-3-4-klassy",
                list: [
                    "решаем сложные задачи",
                    "разбираем основные олимпиадные идеи и&nbsp;темы",
                    "учим не бояться нового",
                ],
                price: "3&nbsp;490",
                priceNumber: 3490,
                schedule: "Группа: пн в&nbsp;17.00",
                ticket: "Абонемент на&nbsp;4&nbsp;занятия по&nbsp;60&nbsp;минут",
                descr: '<div>\
    <p dir="ltr"><strong>Основная цель обучения &ndash; развитие олимпиадного мышления.</strong></p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr"><strong>Мы учим детей решать сложные задачи, разбираем c&nbsp;ними основные олимпиадные идеи и&nbsp;темы и&nbsp;учим не бояться нового.</strong></p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr">На занятиях дети изучают математику c&nbsp;помощью Кубика Сома, танграма, логических задачек, олимпиад и&nbsp;игр на&nbsp;пространственное мышление!</p>\
    <p dir="ltr"><span>Дети занимаются увлекательной математикой 2х2, играют в&nbsp;интеллектуальные игры.</span></p>\
    <p dir="ltr"><span><span>&nbsp;</span></span></p>\
    <p dir="ltr"><span>Вести занятия будет Салахетдинов&nbsp;Руслан, образование: РТУ Инноватика, преподавал в&nbsp;МММФ (малый мехмат МГУ), проводил летние и&nbsp;зимние выездные школы МММФ, c&nbsp;2017 года стажировался и&nbsp;обучает по&nbsp;математической программе 2х2.</span></p>\
    <p><span>&nbsp;</span></p>\
    </div>\
    <p dir="ltr">&nbsp;</p>\
    ',
            },
            {
                id: 666,
                img: "/static/images/courses/image18.jpg",
                title: "ЛОГОПЕД (от&nbsp;5&nbsp;лет)",
                titleEng: "logoped-ot-5-let",
                list: [
                    "Индивидуальная диагностика",
                    "Индивидуальные онлайн занятия для детей от&nbsp;5&nbsp;лет",
                ],
                price: "1&nbsp;000 / 3&nbsp;600",
                priceNumber: 1000,
                schedule: "Занятия: вт-чт  по&nbsp;записи",
                ticket: "Первая консультация - диагностика 30&nbsp;минут / Абонемент на&nbsp;4&nbsp;занятия по&nbsp;30&nbsp;минут",
                descr: '<div>\
    <p dir="ltr"><span>Любое нарушение речи в&nbsp;той или иной степени может отразиться на&nbsp;деятельности и&nbsp;поведении ребёнка в&nbsp;целом. Поэтому так важно заботиться о своевременном развитии речи детей, уделять внимание ее чистоте и&nbsp;правильности.</span></p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr">Ведь Речь &mdash; это путь к&nbsp;общению, новым впечатлениям и&nbsp;жизненному опыту, путь к&nbsp;расширению представлений об окружающем его мире. Формирование речи у детей является необходимым условием для полноценного развития личности.</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr"><strong>В программу обучения входит:</strong></p>\
    <ul>\
    <li dir="ltr">\
    <p dir="ltr"><span>исправление звукопроизношения</span></p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr"><span>развитие фонематического восприятия</span></p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr"><span>формирование лексико-грамматических средств&nbsp;языка</span></p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr"><span>развитие связной речи</span></p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr"><span>подготовка к&nbsp;обучению грамоте (слоговой, фонемный анализ и&nbsp;синтез слов)</span></p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr"><span>формирование слоговой структуры слова</span></p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr"><span>совершенствование ритмоинтонационной стороны речи</span></p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr"><span>развитие психических процессов: памяти, внимания, мышления, воображения</span></p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr"><span>развитие подвижности артикуляционного аппарата, дыхательная гимнастика</span></p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr"><span>развитие мелкой моторики пальцев&nbsp;рук у детей</span></p>\
    </li>\
    </ul>\
    </div>\
    <p dir="ltr">&nbsp;</p>\
    ',
            },
            {
                id: 777,
                img: "/static/images/courses/image9.jpg",
                title: "МЕНТАЛЬНАЯ АРИФМЕТИКА (от&nbsp;6&nbsp;лет)",
                titleEng: "mentalnaya-arifmetika-ot-6-let",
                list: [
                    "навыки быстрого вычисления",
                    "развитие аналитических способностей",
                ],
                price: "3&nbsp;600",
                priceNumber: 3600,
                schedule: "Занятия: вт  в&nbsp;17.00",
                ticket: "Абонемент на&nbsp;4&nbsp;занятия по&nbsp;60&nbsp;минут",
                descr: '<div>\
    <p dir="ltr">Ментальная арифметика способна развить умственные способности ребенка настолько, что любые арифметические задачи станут для него простым и&nbsp;быстрым вычислением в&nbsp;уме.</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr">&nbsp;Ментальная арифметика не только помогает освоить навыки быстрого вычисления, но и&nbsp;способствует развитию аналитических способностей.&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr"><strong>Главными целями ментальной арифметики являются:&nbsp;</strong></p>\
    <ul>\
    <li dir="ltr">\
    <p dir="ltr"><span>концентрация внимания,&nbsp;</span></p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr"><span>развитие фотографической памяти и&nbsp;творческого мышления,&nbsp;</span></p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr"><span>развитие логики и&nbsp;воображения,&nbsp;</span></p>\
    </li>\
    <li dir="ltr">\
    <p dir="ltr"><span>развитие слуха и&nbsp;наблюдательности&nbsp; у ребенка.</span></p>\
    </li>\
    </ul>\
    </div>\
    <p dir="ltr">&nbsp;</p>\
    ',
            },
            {
                id: 888,
                img: "/static/images/courses/image14.png",
                title: "СКОРОЧТЕНИЕ (от&nbsp;8&nbsp;лет)",
                titleEng: "skorochtenie-ot-8-let",
                list: [
                    "развитие периферического зрения",
                    "преодоление привычки проговаривать текст",
                    "развитие навыков&nbsp;внимания",
                    "работа над пониманием содержания текста",
                    "развитие разных видов&nbsp;памяти",
                ],
                price: "3&nbsp;600",
                priceNumber: 3600,
                schedule: "Занятия: пят в&nbsp;17.00",
                ticket: "Абонемент на&nbsp;4&nbsp;занятия по&nbsp;60&nbsp;минут",
                descr: '<div>\
    <p dir="ltr">Программа направлена на&nbsp;освоение навыка быстрого чтения и&nbsp;развития памяти.&nbsp;</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr"><strong>Основные направления, по&nbsp;которым идет работа на&nbsp;наших занятиях:</strong></p>\
    <p dir="ltr">&nbsp;- развитие периферического зрения;&nbsp;</p>\
    <p dir="ltr">&nbsp;- преодоление привычки проговаривать текст;</p>\
    <p dir="ltr">- развитие навыков&nbsp;внимания;</p>\
    <p dir="ltr">- работа над пониманием содержания текста;</p>\
    <p dir="ltr">- развитие разных видов&nbsp;памяти (не только визуальной, но и&nbsp;слуховой, зрительной).&nbsp;</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr">Включены элементы на&nbsp;поддержание мотивации, упражнения на&nbsp;групповую динамику и&nbsp;позитивное мышление.</p>\
    </div>\
    <p dir="ltr">&nbsp;</p>\
    ',
            },
            {
                id: 999,
                img: "/static/images/courses/image13.png",
                title: "ПОДГОТОВКА К ШКОЛЕ ЭКСПРЕСС (от&nbsp;6-7&nbsp;лет)",
                titleEng: "podgotovka-k-shkole-ekspress-ot-6-7-let",
                list: [
                    "Диагностика готовности ребенка к&nbsp;школе",
                    "Групповые онлайн-занятия для детей 6-7&nbsp;лет",
                    "Экспресс курс (3&nbsp;месяца до школы)",
                ],
                price: "2&nbsp;000",
                priceNumber: 2000,
                schedule: "Занятия: вт-чт в&nbsp;11.00",
                ticket: "Абонемент на&nbsp;4&nbsp;занятия по&nbsp;60&nbsp;минут",
                descr: '<div>\
    <p dir="ltr">Подготовка к&nbsp;школе &ndash; углубленный курс обучения для будущих первоклассников. Подготовка к&nbsp;школе включает в&nbsp;себя 3&nbsp;основных блока: математика, развитие речи, окружающий мир.</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr">Дети учатся читать и&nbsp;пересказывать тексты, решать арифметические задачи, писать небольшие слова прописными буквами, знакомятся c&nbsp;окружающим миром.</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr">Готовность к&nbsp;школе включает в&nbsp;себя не только академические знания, но и&nbsp;сформированную мотивацию к&nbsp;обучению. Очень важно научить ребенка взаимодействовать со сверстниками, слушать учителя и&nbsp;сосредоточенно работать на&nbsp;уроке. Все эти важные навыки ваш ребенок получит на&nbsp;занятиях</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr"><strong>Что развивают занятия?</strong></p>\
    <p dir="ltr">- умение читать, пересказывать текст, составлять рассказ по&nbsp;картинке;</p>\
    <p dir="ltr">- умение считать в&nbsp;пределах 100, решать арифметические задачи;</p>\
    <p dir="ltr">- умение красиво писать в&nbsp;тетради;</p>\
    <p dir="ltr">- зрительную и&nbsp;слуховую память, внимание;</p>\
    <p dir="ltr">- мелкую моторику и&nbsp;речь;</p>\
    <p dir="ltr">- интерес к&nbsp;школьному обучению;</p>\
    <p dir="ltr">- уверенность в&nbsp;себе;</p>\
    <p dir="ltr">- аккуратность и&nbsp;самостоятельность.</p>\
    </div>\
    <p dir="ltr">&nbsp;</p>\
    ',
            },
            {
                id: 1111,
                img: "/static/images/courses/image13.jpg",
                title: "Английский язык 6+",
                titleEng: "angliyskiy-yazik-6+",
                list: [
                    "Индивидуальные онлайн занятия для детей и&nbsp;взрослых ",
                    "Групповые онлайн занятия для детей от&nbsp;5&nbsp;лет",
                ],
                price: "2&nbsp;800",
                priceNumber: 2800,
                schedule: "Занятия: пн-ср 17.00",
                ticket: "Абонемент на&nbsp;4 занятия по&nbsp;60&nbsp;минут",
                descr: '<div>\
    <p dir="ltr">Наша задача влюбить детей в&nbsp;английский язык. И для этого преподаватель увлекательно и&nbsp;ярко подаёт материал, начиная c&nbsp;самого простого. Учитель английского онлайн использует разнообразные интерактивные инструменты. Среди них: интересные красочные иллюстрации, занимательные задания, коммуникативные игры.</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr">Курс начинается c&nbsp;самого простого и&nbsp;включает темы, которые понятны и&nbsp;просты любому ребенку в&nbsp;этом возрасте. Дети научатся приветствовать друг друга, говорить о себе и&nbsp;своем доме, эмоциях и&nbsp;чувствах, семье, игрушках и&nbsp;школе, еде, домашних животных, одежде, своих увлечениях и&nbsp;ежедневных занятиях.</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr">Постепенно словарный запас детей будет расширяться. Они будут узнавать больше фраз и&nbsp;грамматических конструкций. Научатся понимать английскую речь на&nbsp;слух, отвечать на&nbsp;простые вопросы по&nbsp;темам.</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr">Дистанционный формат позволяет детям заниматься практически в&nbsp;любом месте и&nbsp;с любого устройства.</p>\
    </div>\
    <p dir="ltr">&nbsp;</p>\
    ',
            },
            {
                id: 2222,
                img: "/static/images/courses/image19.jpg",
                title: "Общая физическая подготовка c&nbsp;элементами единоборств&nbsp;(от&nbsp;6&nbsp;л.)",
                titleEng: "obschaya-fizicheskaya-podgotovka-s-elementami-edinoborstv-ot-6-l",
                list: [
                    "улучшение общего физического состояния ребенка",
                    "укрепление мышечного каркаса",
                    "развитие координаций, выносливости, силы, гибкости",
                ],
                price: "3&nbsp;200",
                priceNumber: 3200,
                schedule: "Занятия: вторник, четверг в&nbsp;18.00",
                ticket: "Абонемент на&nbsp;8 занятий по&nbsp;60&nbsp;минут",
                descr: '<div>\
    <p dir="ltr">Общая физическая подготовка предполагает разностороннее развитие физических качеств&nbsp;и функциональных возможностей организма ребенка.</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr">Наши занятия рассчитаны для детей c&nbsp;любым уровнем подготовки и&nbsp;включают в&nbsp;себя различные комплексы упражнений на&nbsp;укрепление мышц, координации и&nbsp;выносливости ребенка.</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr">Наша основная задача, чтобы ребенок занимался c&nbsp;удовольствием и&nbsp;в&nbsp;его повседневной жизни присутствовала физическая нагрузка.</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr"><strong>На что направлены занятия?</strong></p>\
    <p dir="ltr">- улучшение общего физического состояния ребенка;</p>\
    <p dir="ltr">- укрепление мышечного каркаса;</p>\
    <p dir="ltr">- развитие координаций;</p>\
    <p dir="ltr">- выносливости;</p>\
    <p dir="ltr">- силы;</p>\
    <p dir="ltr">- гибкости;</p>\
    <p dir="ltr">- уверенности в&nbsp;себе.</p>\
    </div>\
    <p dir="ltr">&nbsp;</p>\
    ',
            },
            {
                id: 3333,
                img: "/static/images/courses/image15-1.jpg",
                title: "Общая физическая подготовка c&nbsp;элементами танцев&nbsp;(от&nbsp;6&nbsp;лет)",
                titleEng: "obschaya-fizicheskaya-podgotovka-s-elementami-tantsev-ot-6-l",
                list: [
                    "улучшение общего физического состояния ребенка",
                    "укрепление мышечного каркаса",
                    "развитие чувства ритма координаций, выносливости, силы, гибкости",
                ],
                price: "3&nbsp;200",
                priceNumber: 3200,
                schedule: "Занятия: понедельник, среда в&nbsp;17:45",
                ticket: "Абонемент на&nbsp;8 занятий по&nbsp;60&nbsp;минут",
                descr: '<div>\
    <p dir="ltr">Общая физическая подготовка предполагает разностороннее развитие физических качеств&nbsp;и функциональных возможностей организма ребенка.</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr">Наши занятия рассчитаны для детей c&nbsp;любым уровнем подготовки и&nbsp;включают в&nbsp;себя различные комплексы упражнений на&nbsp;укрепление мышц, координации и&nbsp;гибкости ребенка.</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr">Наша основная задача, чтобы ребенок занимался c&nbsp;удовольствием и&nbsp;в&nbsp;его повседневной жизни присутствовала физическая нагрузка.</p>\
    <p dir="ltr">&nbsp;</p>\
    <p dir="ltr"><strong>На что направлены занятия?</strong></p>\
    <p dir="ltr">- улучшение общего физического состояния ребенка;</p>\
    <p dir="ltr">- укрепление мышечного каркаса;</p>\
    <p dir="ltr">- развитие координаций;</p>\
    <p dir="ltr">- выносливости;</p>\
    <p dir="ltr">- гибкости;</p>\
    <p dir="ltr">- чувства ритма;</p>\
    <p dir="ltr">- уверенности в&nbsp;себе.</p>\
    </div>\
    <p dir="ltr">&nbsp;</p>\
    ',
            },
            {
                id: 4444,
                img: "/static/images/courses/image14.png",
                title: "Развитие навыка чтения (от&nbsp;6-7&nbsp;лет)",
                titleEng: "razvitie-navyka-chteniya-ot-6-7-let",
                list: [
                    "тренируем зрительное восприятие и&nbsp;внимание",
                    "зрительно-моторную координацию",
                    "звуко-буквенный анализ",
                    "расширяем словарь ребенка",
                    "учимся грамотно и&nbsp;развёрнуто отвечать на&nbsp;вопросы",
                ],
                price: "2&nbsp;000",
                priceNumber: 2000,
                schedule: "Занятия: вт-чт в&nbsp;15.00",
                ticket: "Абонемент на&nbsp;4&nbsp;занятия по&nbsp;60&nbsp;минут",
                descr: "<p><strong>Занятия направлены на&nbsp;формирование предпосылок, важных для овладения навыком чтения!</strong></p>\
    <p>&nbsp;</p>\
    <p>Вместе c&nbsp;логопедом тренируем:</p>\
    <p>- зрительное восприятие и&nbsp;внимание,<br />-зрительно-моторную координацию,<br />-ориентировку в&nbsp;пространстве,<br />-слухо-речевую память,<br />-звуко-буквенный анализ;<br />- расширяем словарь ребенка,<br />- учимся грамотно и&nbsp;развёрнуто отвечать на&nbsp;вопросы.</p>\
    <p>&nbsp;</p>\
    <p><br />Возможны занятия c&nbsp;уже умеющим читать ребёнком по&nbsp;улучшению техники чтения.</p>\
    <p>&nbsp;</p>\
    <p><br /><strong>Научим вашего ребенка:</strong><br />- Различать буквы и&nbsp;звуки,<br />- Анализировать состав&nbsp;слова,<br />- Понимать и&nbsp;запоминать прочитанное,<br />- Уметь отвечать на&nbsp;вопросы и&nbsp;пересказывать.</p>\
    ",
            },
            {
                id: 5555,
                img: "/static/images/courses/image1.jpeg",
                title: "Творческая мастерская (6+&nbsp;лет)",
                titleEng: "tvorcheskaya-masterskaya-6+-let",
                list: [
                    "рисование и лепка",
                    "творческий процесс по принципу «от простого к сложному»",
                    "индивидуальный результат",
                ],
                price: "400",
                priceNumber: 400,
                schedule: "Группа пятница 16.30",
                ticket: "1&nbsp;занятие 60&nbsp;минут",
                descr: "<p>Пользу творческих занятий для детей сложно переоценить. Даже когда ребенок еще не научился говорить, ходить, рисование и лепка уже присутствуют в жизни ребенка. В творчестве важен процесс, а не результат.</p>\
    <p><br></p>\
    <p>Именно творческий процесс способствует:</p>\
    <p>- развитию памяти,</p>\
    <p>- внимания</p>\
    <p>- усидчивости</p>\
    <p>- воображения</p>\
    <p>- мышления</p>\
    <p>- проявление индивидуальности</p>\
    <p>- мелкой моторики,</p>\
    <p>- оказывает положительное влияние на психику, помогает в учебе.</p>\
    <p><br></p>\
    <p>На наших занятиях педагог адаптирует работу таким образом, чтобы процесс рисования строился от простого к сложному и результат был индивидуален и радовал юного художника.</p>\
    <p><br></p>\
    <p>Онлайн формат позволяет сделать работу максимально самостоятельной!</p>\
    <p><br></p>\
    <p>Дорогие родители, не помогайте ребенку провести линию в точности, как это делает педагог, это его личное творчество и результат Вашего ребенка :)&nbsp;</p>\
    <p><br></p>\
    ",
            },
        ];
    }
}
class DataGetters extends Getters {
    // courses
    get courseById() {
        return (id) => {
            return this.state.courses && this.state.courses.find((c) => c.id === id);
        };
    }
    // form
    get formIsValid() {
        return (formType) => {
            let form = null;
            if (formType === "callback" || formType === "quiz")
                form = this.state.formCall;
            else if (formType === "getPres")
                form = this.state.formPres;
            else if (formType === "faq")
                form = this.state.formFaq;
            const required = form.data.filter((field) => field.validationRequired);
            return required.every((field) => field.isValid);
        };
    }
    get formName() {
        return (formType) => {
            let form = null;
            if (formType === "callback" || formType === "quiz")
                form = this.state.formCall;
            else if (formType === "getPres")
                form = this.state.formPres;
            else if (formType === "faq")
                form = this.state.formFaq;
            return form.data.find((field) => field.name === "name");
        };
    }
    get formPhone() {
        return (formType) => {
            let form = null;
            if (formType === "callback" || formType === "quiz")
                form = this.state.formCall;
            else if (formType === "getPres")
                form = this.state.formPres;
            else if (formType === "faq")
                form = this.state.formFaq;
            return form.data.find((field) => field.name === "phone");
        };
    }
    get formMail() {
        return (formType) => {
            let form = null;
            if (formType === "callback" || formType === "quiz")
                form = this.state.formCall;
            else if (formType === "getPres")
                form = this.state.formPres;
            else if (formType === "faq")
                form = this.state.formFaq;
            return form.data.find((field) => field.name === "mail");
        };
    }
    get formQuestion() {
        return (formType) => {
            let form = null;
            if (formType === "callback" || formType === "quiz")
                form = this.state.formCall;
            else if (formType === "getPres")
                form = this.state.formPres;
            else if (formType === "faq")
                form = this.state.formFaq;
            return form.data.find((field) => field.name === "question");
        };
    }
    get formData() {
        return (formType) => {
            let form = null;
            if (formType === "callback" || formType === "quiz")
                form = this.state.formCall;
            else if (formType === "getPres")
                form = this.state.formPres;
            else if (formType === "faq")
                form = this.state.formFaq;
            const formData = Object.assign({});
            formData.title =
                form.title &&
                    form.title.toString() &&
                    form.title.toString().replace(/&nbsp;/g, " ");
            formData.screen =
                form.screen &&
                    form.screen.toString() &&
                    form.screen.toString().replace(/&nbsp;/g, " ");
            formData.name =
                (this.getters.formName(formType) &&
                    this.getters.formName(formType).value &&
                    this.getters.formName(formType).value.toString()) ||
                    "";
            formData.phone =
                (this.getters.formPhone(formType) &&
                    this.getters.formPhone(formType).value &&
                    this.getters.formPhone(formType).value.toString()) ||
                    "";
            if (this.getters.formMail(formType))
                formData.mail =
                    (this.getters.formMail(formType).value &&
                        this.getters.formMail(formType).value.toString()) ||
                        "";
            if (formType === "faq")
                formData.question =
                    (this.getters.formQuestion(formType) &&
                        this.getters.formQuestion(formType).value &&
                        this.getters.formQuestion(formType).value.toString()) ||
                        "";
            return formData;
        };
    }
    // quiz
    get quizAnswer() {
        return (index) => {
            return this.state.quiz.data[index].value;
        };
    }
    get quizIsFilled() {
        return this.state.quiz.data.every((item) => item.value.length > 0);
    }
}
class DataMutations extends Mutations {
    // form
    setFormValidationIsShown(payload) {
        let form = null;
        if (payload.formType === "callback" || payload.formType === "quiz")
            form = this.state.formCall;
        else if (payload.formType === "getPres")
            form = this.state.formPres;
        else if (payload.formType === "faq")
            form = this.state.formFaq;
        form.validationIsShown = payload.validationIsShown;
    }
    startFormLoading(formType) {
        let form = null;
        if (formType === "callback" || formType === "quiz")
            form = this.state.formCall;
        else if (formType === "getPres")
            form = this.state.formPres;
        else if (formType === "faq")
            form = this.state.formFaq;
        form.isLoading = true;
        form.error = null;
    }
    finishFormLoading({ formType, errMsg, }) {
        let form = null;
        if (formType === "callback" || formType === "quiz")
            form = this.state.formCall;
        else if (formType === "getPres")
            form = this.state.formPres;
        else if (formType === "faq")
            form = this.state.formFaq;
        form.isLoading = false;
        form.error = errMsg || null;
    }
    clearForm(formType) {
        let form = null;
        if (formType === "callback" || formType === "quiz")
            form = this.state.formCall;
        else if (formType === "getPres")
            form = this.state.formPres;
        else if (formType === "faq")
            form = this.state.formFaq;
        const fields = form.data;
        fields.forEach((field) => {
            field.value = null;
            field.isValid = false;
            field.validationRequired = true;
            field.errorType = "empty";
            field.errorMsg =
                field.errorType &&
                    form.errors.find((f) => f.type === field.errorType).msg;
        });
        form.validationIsShown = false;
    }
    setFormField(payload) {
        // @ts-ignore
        payload.field[payload.prop] = payload.value;
    }
    activateFormField(field) {
        field.isShown = true;
        field.validationRequired = true;
    }
    deactivateFormField(field) {
        field.isShown = false;
        field.validationRequired = false;
    }
    setFormCallTitle(title) {
        this.state.formCall.title = title;
    }
    setFormCallScreen(screen) {
        this.state.formCall.screen = screen;
    }
    // quiz
    startQuizLoading() {
        this.state.quiz.isLoading = true;
        this.state.quiz.error = null;
    }
    finishQuizLoading() {
        this.state.quiz.isLoading = false;
        this.state.quiz.error = null;
    }
    clearQuiz() {
        const fields = this.state.quiz.data;
        fields.forEach((field, index) => {
            if (index === 0)
                field.value = [
                    [
                        this.state.quiz.data[index].answers[0],
                        this.state.quiz.data[index].answersExtra[0],
                    ],
                ];
            else
                field.value = [];
        });
        this.state.quiz.isLoading = false;
        this.state.quiz.error = null;
    }
    /** payload: {index: stepIndex, value: answer value, valueIndex: index of value in values array, subValueIndex: index in value[valueIndex]} */
    updateQuizField(payload) {
        const field = this.state.quiz.data[payload.stepIndex];
        const fieldValue = field.value;
        if (payload.stepIndex > 0) {
            // @ts-ignore
            const indexInclude = fieldValue.indexOf(payload.value);
            // @ts-ignore
            if (indexInclude < 0)
                fieldValue.push(payload.value);
            else
                fieldValue.splice(indexInclude, 1);
        }
        else {
            // @ts-ignore
            if (fieldValue[payload.valueIndex])
                fieldValue[payload.valueIndex].splice(payload.subValueIndex, 1, payload.value);
            // @ts-ignore
            else
                fieldValue.push(payload.value);
        }
    }
    removeQuizValue(payload) {
        const field = this.state.quiz.data[payload.stepIndex];
        const fieldValue = field.value;
        fieldValue.splice(payload.valueIndex, 1);
    }
    setCourses({ courses }) {
        this.state.courses = courses;
    }
    setContacts({ address, mapurl, phone, watsapp, }) {
        this.state.address = address;
        this.state.addressLink = mapurl;
        this.state.phone = phone;
        this.state.whatsapp = watsapp;
    }
}
class DataActions extends Actions {
    // form call
    updateFormField({ formType, name, value, }) {
        let form = null;
        if (formType === "callback" || formType === "quiz")
            form = this.state.formCall;
        else if (formType === "getPres")
            form = this.state.formPres;
        else if (formType === "faq")
            form = this.state.formFaq;
        const field = form.data.find((field) => field.name === name);
        this.commit("setFormField", { field, prop: "value", value });
        let isValid = field.value && !!field.value.toString();
        let errorType = null;
        if (!field.value && field.validationRequired)
            errorType = "empty";
        if (field.name === "mail") {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            isValid =
                field.value &&
                    !!field.value.toString() &&
                    re.test(String(field.value).toLowerCase());
            if (field.value &&
                !!field.value.toString() &&
                !re.test(String(field.value).toLowerCase()))
                errorType = "wrongMail";
        }
        else if (field.name === "phone") {
            isValid =
                field.value &&
                    !!field.value.toString() &&
                    field.value.match(/\d/g).length === 11;
            if (field.value &&
                !!field.value.toString() &&
                field.value.match(/\d/g).length !== 11)
                errorType = "wrongPhone";
        }
        this.commit("setFormField", { field, prop: "errorType", value: errorType });
        this.commit("setFormField", { field, prop: "isValid", value: isValid });
        const errorMsg = field.errorType &&
            form.errors.find((f) => f.type === field.errorType).msg;
        this.commit("setFormField", { field, prop: "errorMsg", value: errorMsg });
    }
    sendForm(formType) {
        return new Promise((resolve, reject) => {
            const formIsValid = this.getters.formIsValid(formType);
            if (!formIsValid) {
                this.commit("setFormValidationIsShown", {
                    formType,
                    validationIsShown: true,
                });
                reject();
                return;
            }
            this.commit("startFormLoading", formType);
            const data = this.getters.formData(formType);
            const url = "https://script.google.com/macros/s/AKfycbwDUYcQkMo68t4krbbGwaW8EwVxeDOGC121-hNwhBiIoMFy43orHSouUuheOCnKat0y/exec";
            const options = {
                method: "POST",
                headers: { "Content-Type": "text/plain" },
                data,
                url,
            };
            axios(options)
                .then((response) => {
                this.commit("setFormValidationIsShown", {
                    formType,
                    validationIsShown: false,
                });
                this.commit("finishFormLoading", { formType });
                resolve();
            })
                .catch((error) => {
                this.commit("setFormValidationIsShown", {
                    formType,
                    validationIsShown: true,
                });
                const errMsg = (error &&
                    error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    null;
                this.commit("finishFormLoading", { formType, errMsg });
                reject();
            });
        });
    }
    loadCourses() {
        return new Promise((resolve, reject) => {
            const options = {
                method: "GET",
                url: "https://admin-school.clubmalina.ru/api/course/",
            };
            axios(options)
                .then((response) => {
                const { data } = response;
                this.commit("setCourses", { courses: data });
                resolve();
            })
                .catch((err) => {
                console.error(err);
                reject();
            });
        });
    }
    loadContacts() {
        return new Promise((resolve, reject) => {
            const options = {
                method: "GET",
                url: "https://admin-school.clubmalina.ru/api/contacts/",
            };
            axios(options)
                .then((response) => {
                const { data } = response;
                const { address, mapurl, phone, watsapp } = data[0];
                this.commit("setContacts", { address, mapurl, phone, watsapp });
                resolve();
            })
                .catch((err) => {
                console.error(err);
                reject();
            });
        });
    }
    loadData() {
        // @ts-ignore
        this.dispatch("loadCourses");
        // @ts-ignore
        this.dispatch("loadContacts");
    }
}
export const DataStore = new Module({
    namespaced,
    state: DataState,
    getters: DataGetters,
    mutations: DataMutations,
    actions: DataActions,
});
export const dataMapper = createMapper(DataStore);
